/* SIMPATICO PDP · SRP configurator v2 behaviour. Markup lives in snippets/sim-srp-configurator.liquid. */
(function () {
'use strict';
function bootOne(root) {
  if (!root || root.getAttribute('data-srp2-booted') === 'true') return;
  root.setAttribute('data-srp2-booted', 'true');

  var section = root.closest('[data-sim-section]') || document;
  var format = (section.getAttribute && section.getAttribute('data-money-format')) || ('$' + '{' + '{amount}' + '}');
  var productTitle = root.getAttribute('data-product-title') || '';
  var isPedals = (root.getAttribute('data-kind') || 'pedals') === 'pedals';
  // Stocked mode (e.g. SIMGRADE): in-house stock, generic variant picker, no factory build options.
  var stocked = root.getAttribute('data-mode') === 'stocked';
  var sideInputs = root.querySelectorAll('[name="srp_side"]');
  var colourSelects = root.querySelectorAll('[data-srp2-colour]');
  function mountSide() { var s = root.querySelector('[name="srp_side"]:checked'); return s ? s.value : ''; }
  function rowQty(handle) { var c = root.querySelector('[data-srp2-qty="' + handle + '"]:checked'); return c ? Math.max(1, Number(c.value) || 1) : 1; }
  function rowColour(handle) { var s = root.querySelector('[data-srp2-colour="' + handle + '"]'); return s ? s.value : ''; }
  var addons = { products: [] };
  try { addons = JSON.parse(root.querySelector('[data-srp2-addons]').textContent); } catch (e) {}
  var sectionVariants = [];
  try { sectionVariants = JSON.parse((section.querySelector('[data-sim-variants]') || {}).textContent || '[]'); } catch (e) {}

  var finishInputs = root.querySelectorAll('[name="srp_finish"]');
  var plateDots = root.querySelectorAll('[data-srp2-plate]');
  var addonInputs = root.querySelectorAll('[data-srp2-addon]');
  var spacingWrap = root.querySelector('[data-srp2-spacing]');
  var spacingInputs = root.querySelectorAll('[name="srp_spacing"]');
  var spacingHint = root.querySelector('[data-srp2-spacing-hint]');
  var notes = root.querySelector('[data-srp2-notes]');
  var totalEl = root.querySelector('[data-srp2-total]');
  var countEl = root.querySelector('[data-srp2-sumcount]');
  var linesEl = root.querySelector('[data-srp2-lines]');
  var plate = null;
  var submitting = false;

  /* ---------- money (mirrors sim-pdp.js, kept local so this snippet stands alone) */
  function money(cents) {
    var value = Math.round(cents), abs = Math.abs(value);
    var whole = Math.floor(abs / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var cent = ('00' + (abs % 100)).slice(-2);
    var noDec = /amount_no_decimals/.test(format);
    var out = (value < 0 ? '-' : '') + (noDec ? whole : whole + '.' + cent);
    return format.replace(/\{\{\s*\w+\s*\}\}/, out);
  }
  function norm(v) { return String(v || '').toLowerCase().replace(/\s+/g, ' ').trim(); }

  /* ---------- selection state */
  function finishInput() { return root.querySelector('[name="srp_finish"]:checked') || finishInputs[0]; }
  function finish() { var f = finishInput(); return f ? f.value : 'gray'; }
  function mainVariant() {
    var f = finishInput();
    if (!f) return null;
    return { id: Number(f.getAttribute('data-variant-id')), price: Number(f.getAttribute('data-price') || 0), label: f.getAttribute('data-label') || f.value };
  }
  function clutchSelected() {
    var yes = false;
    addonInputs.forEach(function (i) { if (i.checked && /clutch/.test(norm(i.getAttribute('data-handle')) + ' ' + norm(i.getAttribute('data-title')))) yes = true; });
    return yes;
  }
  // Stocked sets can ship with a clutch already (e.g. a Throttle, Brake & Clutch variant).
  function mainHasClutch() { if (!stocked) return false; var mv = mainVariant(); return !!(mv && /clutch/i.test(mv.label)); }
  function isClutchInput(i) { return /clutch/.test(norm(i.getAttribute('data-handle')) + ' ' + norm(i.getAttribute('data-title'))); }
  function pedalCount() { return (clutchSelected() || mainHasClutch()) ? '3' : '2'; }
  // Hide the clutch add-on while the chosen variant already includes one.
  function paintClutchRow() {
    if (!stocked) return;
    var hide = mainHasClutch();
    addonInputs.forEach(function (i) {
      if (!isClutchInput(i)) return;
      if (hide && i.checked) i.checked = false;
      var row = i.closest('[data-srp2-item]');
      if (!row) return;
      row.hidden = hide;
      var b = row.querySelector('[data-srp2-expand]');
      var d = b && document.getElementById(b.getAttribute('aria-controls'));
      if (d && hide) { d.hidden = true; b.setAttribute('aria-expanded', 'false'); }
    });
  }

  /* ---------- variant matching (v1 logic, unchanged in substance) */
  var COLOURS = ['gray', 'grey', 'black', 'red', 'blue', 'green', 'orange', 'purple', 'yellow', 'silver', 'golden', 'gold'];
  function matches(variant, colour, count) {
    var s = [variant.title, variant.option1, variant.option2, variant.option3].map(norm).join(' | ');
    var c = norm(colour);
    var hasColourWord = COLOURS.some(function (w) { return s.indexOf(w) !== -1; });
    var colourOk = c === '' || s.indexOf(c) !== -1 || !hasColourWord;
    var countOk = s.indexOf(count + ' pedal') !== -1 || s.indexOf(count + '-pedal') !== -1 ||
      (s.indexOf('2 pedal') === -1 && s.indexOf('2-pedal') === -1 && s.indexOf('3 pedal') === -1 && s.indexOf('3-pedal') === -1);
    return colourOk && countOk && variant.available;
  }
  function pickVariant(p) {
    var colour = rowColour(p.handle) || finish();
    var count = pedalCount();
    return p.variants.find(function (v) { return matches(v, colour, count); }) ||
           p.variants.find(function (v) { return v.available; }) || p.variants[0];
  }
  function selectedAddons() {
    var out = [];
    addonInputs.forEach(function (i) {
      if (!i.checked) return;
      var p = addons.products.find(function (x) { return x.handle === i.getAttribute('data-handle'); });
      if (!p) return;
      var v = pickVariant(p);
      if (!v) return;
      out.push({ handle: p.handle, title: p.short || p.title, variantId: Number(v.id), variantTitle: v.title, price: Number(v.price || 0), qty: rowQty(p.handle) });
    });
    return out;
  }

  /* ---------- painting */
  function paintRows() {
    addons.products.forEach(function (p) {
      var input = root.querySelector('[data-srp2-addon][data-handle="' + p.handle + '"]');
      if (!input) return;
      var v = pickVariant(p);
      var priceEl = root.querySelector('[data-srp2-price="' + p.handle + '"]');
      var subEl = root.querySelector('[data-srp2-sub="' + p.handle + '"]');
      var q = rowQty(p.handle);
      if (priceEl && v) priceEl.textContent = '+' + money(v.price * q);
      if (subEl && v) subEl.textContent = q > 1 ? q + ' × ' + money(v.price) : ((v.title && /pedal/i.test(v.title)) ? v.title : '');
      input.disabled = !(v && v.available);
    });
  }
  function paintPlate() {
    var lbl = root.querySelector('[data-srp2-plate-label]');
    var prev = root.querySelector('[data-srp2-plate-preview]');
    if (!plate) return;
    if (lbl) lbl.textContent = plate.name + (plate.included ? ' · included' : ' · +' + money(plate.price));
    if (prev) {
      var img = prev.querySelector('[data-srp2-plate-img]');
      var txt = prev.querySelector('[data-srp2-plate-text]');
      if (plate.img && !plate.included) { img.src = plate.img; txt.textContent = plate.name + ' plates, added to your build'; prev.hidden = false; }
      else prev.hidden = true;
    }
  }
  function paintSpacing() {
    if (!spacingWrap) return;
    var hide = clutchSelected();
    spacingWrap.hidden = hide;
    if (hide) { spacingInputs.forEach(function (i, n) { i.checked = n === 0; }); }
    var custom = root.querySelector('[name="srp_spacing"]:checked');
    var isCustom = custom && custom.value === 'Custom';
    if (notes) notes.hidden = !isCustom;
    if (spacingHint) spacingHint.textContent = isCustom
      ? 'Describe the spacing you want below, and we will confirm it with you before the set ships.'
      : 'Not sure? Standard fits most rigs and can be re-spaced on the plate later.';
  }
  function paintSummary() {
    var mv = mainVariant();
    var lines = [];
    if (mv) lines.push([productTitle + ' · ' + mv.label, mv.price]);
    if (plate && !plate.included) lines.push(['Pedal plates · ' + plate.name, plate.price]);
    selectedAddons().forEach(function (a) {
      lines.push([a.title + ((a.variantTitle && a.variantTitle !== 'Default Title') ? ' · ' + a.variantTitle : '') + (a.qty > 1 ? ' × ' + a.qty : ''), a.price * a.qty]);
    });
    var total = lines.reduce(function (s, l) { return s + l[1]; }, 0);
    if (totalEl) totalEl.textContent = money(total);
    if (countEl) countEl.textContent = 'Your build · ' + lines.length + (lines.length === 1 ? ' item' : ' items') + (isPedals ? ' · ' + pedalCount() + ' pedal' : (mountSide() ? ' · ' + mountSide().toLowerCase() + ' side' : ''));
    if (linesEl) linesEl.innerHTML = lines.map(function (l) {
      return '<div class="srp2__line"><span>' + l[0].replace(/</g, '&lt;') + '</span><span>' + money(l[1]) + '</span></div>';
    }).join('');
    section.querySelectorAll('[data-sim-sticky-price]').forEach(function (el) { el.textContent = money(total); });
  }
  function paintFinish() {
    var mv = mainVariant();
    if (!mv) return;
    var lbl = root.querySelector('[data-srp2-finish-label]');
    if (lbl) lbl.textContent = mv.label;
    var idInput = section.querySelector('[data-sim-variant-id]');
    if (idInput) idInput.value = mv.id;
    var priceEl = section.querySelector('[data-sim-price]');
    if (priceEl) priceEl.textContent = money(mv.price);
    var sv = sectionVariants.find(function (v) { return Number(v.id) === mv.id; });
    var mainImg = section.querySelector('[data-sim-gallery-main] img');
    if (sv && sv.featured_image && sv.featured_image.src && mainImg) {
      mainImg.setAttribute('src', sv.featured_image.src);
      mainImg.removeAttribute('srcset');
      section.dispatchEvent(new CustomEvent('sim:gallery:sync', { detail: { src: sv.featured_image.src } }));
    }
    if (sv) document.dispatchEvent(new CustomEvent('sim:variant:change', { bubbles: true, detail: { variant: sv } }));
    if (stocked && sv) paintStock(sv);
    try { var u = new URL(window.location.href); u.searchParams.set('variant', mv.id); window.history.replaceState({}, '', u.toString()); } catch (e) {}
  }
  // Stocked mode: the configurator replaces the standard picker, so keep the
  // availability row in step with the chosen variant (mirrors the facts block).
  function paintStock(sv) {
    var el = section.querySelector('[data-sim-stock]');
    if (!el) return;
    var row = section.querySelector('[data-sim-stock-row]');
    var state, txt;
    if (sv.bo_state === 'backorder' || sv.bo_state === 'preorder') {
      state = 'backorder'; txt = sv.bo_state === 'preorder' ? 'Pre-order' : 'Backordered';
    } else if (sv.available) {
      state = 'in';
      var q = Number(sv.inventory_quantity);
      txt = (sv.inventory_management && q > 0 && q <= 5) ? el.getAttribute('data-low-stock') + ' — ' + q + ' left' : el.getAttribute('data-in-stock');
    } else {
      state = 'out'; txt = el.getAttribute('data-out-stock');
    }
    el.textContent = txt;
    if (row) row.setAttribute('data-state', state);
  }
  function paintAll() { paintClutchRow(); paintRows(); paintPlate(); paintSpacing(); paintSummary(); paintAddLabels(); }

  /* ---------- cart */
  function cartItems() {
    var mv = mainVariant();
    if (!mv || !mv.id) throw new Error('Pick a finish first.');
    var form = section.querySelector('[data-sim-product-form]');
    var qtyEl = form ? form.querySelector('[name="quantity"]') : null;
    var qty = qtyEl ? Math.max(1, Number(qtyEl.value || 1)) : 1;
    var list = selectedAddons();
    var count = pedalCount();
    var sp = root.querySelector('[name="srp_spacing"]:checked');
    var spacing = count === '2' ? (sp ? sp.value : 'Position A - Standard') : 'Position E - 3 Pedal Setup';
    var addonText = list.length ? list.map(function (a) { return a.title + ((a.variantTitle && a.variantTitle !== 'Default Title') ? ' - ' + a.variantTitle : '') + (a.qty > 1 ? ' x' + a.qty : ''); }).join(', ') : 'None';
    var props = stocked ? {} : { 'Configured Product': productTitle, 'Finish': mv.label };
    var child = { '_Configured With': productTitle, '_Finish': mv.label, '_Parent Variant ID': String(mv.id) };
    if (isPedals && !stocked) {
      props['Pedal Color'] = plate ? plate.name : 'Standard';
      props['Pedal Count'] = count + ' Pedal';
      props['Pedal Position'] = spacing;
      child['_Pedal Color'] = plate ? plate.name : 'Standard';
      child['_Pedal Count'] = count + ' Pedal';
    } else if (mountSide()) {
      props['Mount Side'] = mountSide();
      child['_Mount Side'] = mountSide();
    }
    if (!stocked || list.length) props['Selected Add-ons'] = addonText;
    if (isPedals && spacing === 'Custom' && notes && notes.value.trim()) props['Build notes'] = notes.value.trim().slice(0, 500);
    var items = [{ id: mv.id, quantity: qty, properties: props }];
    if (plate && !plate.included && plate.variantId) items.push({ id: plate.variantId, quantity: qty, properties: Object.assign({ '_Option Type': 'Colored Pedals' }, child) });
    list.forEach(function (a) { items.push({ id: a.variantId, quantity: qty * (a.qty || 1), properties: child }); });
    return items;
  }
  function setBusy(busy, label) {
    section.querySelectorAll('[data-sim-submit], [data-sim-sticky-atc]').forEach(function (b) {
      b.disabled = busy;
      var t = b.querySelector('[data-sim-submit-text]') || b;
      if (busy) { b.setAttribute('data-srp2-orig', t.textContent); t.textContent = label || 'Adding your build...'; }
      else if (b.getAttribute('data-srp2-orig')) { t.textContent = b.getAttribute('data-srp2-orig'); b.removeAttribute('data-srp2-orig'); }
    });
  }
  function addBuild(e) {
    if (e) { e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation(); }
    if (submitting) return;
    var items;
    try { items = cartItems(); } catch (err) { alert(err.message); return; }
    submitting = true; setBusy(true);
    var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(rootPath + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (b) { if (!r.ok) throw new Error(b.description || b.message || 'Could not add this build to your cart.'); return b; }); })
      .then(function () { window.location.href = rootPath + 'cart'; })
      .catch(function (err) { alert(err.message); submitting = false; setBusy(false); });
  }

  /* ---------- wiring */
  finishInputs.forEach(function (i) { i.addEventListener('change', function () { paintFinish(); paintAll(); }); });
  plateDots.forEach(function (d) {
    d.addEventListener('click', function () {
      if (d.getAttribute('data-avail') === 'false') return;
      plateDots.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
      d.setAttribute('aria-pressed', 'true');
      var price = Number(d.getAttribute('data-price') || 0);
      plate = { name: d.getAttribute('data-name'), price: price, included: price <= 100, variantId: Number(d.getAttribute('data-variant-id')), img: d.getAttribute('data-img') };
      paintAll();
    });
  });
  addonInputs.forEach(function (i) { i.addEventListener('change', paintAll); });
  // Choosing a quantity switches that add-on on, so picking "2" is enough.
  root.querySelectorAll('[data-srp2-qty]').forEach(function (r) {
    r.addEventListener('change', function () {
      var inp = root.querySelector('[data-srp2-addon][data-handle="' + r.getAttribute('data-srp2-qty') + '"]');
      if (inp && !inp.checked && !inp.disabled) inp.checked = true;
      paintAll();
    });
  });
  spacingInputs.forEach(function (i) { i.addEventListener('change', paintSpacing); });
  colourSelects.forEach(function (s) { s.addEventListener('change', paintAll); });
  sideInputs.forEach(function (i) { i.addEventListener('change', function () {
    var lbl = root.querySelector('[data-srp2-side-label]');
    if (lbl) lbl.textContent = mountSide();
    paintSummary();
  }); });
  // Expandable rows: tap the item to see a large image and the fuller description.
  root.querySelectorAll('[data-srp2-expand]').forEach(function (b) {
    b.addEventListener('click', function () {
      var panel = document.getElementById(b.getAttribute('aria-controls'));
      if (!panel) return;
      var open = b.getAttribute('aria-expanded') === 'true';
      b.setAttribute('aria-expanded', open ? 'false' : 'true');
      panel.hidden = open;
      var lbl = b.querySelector('[data-srp2-chev-label]');
      if (lbl) lbl.textContent = open ? 'Details' : 'Hide';
      var img = panel.querySelector('img[data-src]');
      if (img && !open) { img.src = img.getAttribute('data-src'); img.removeAttribute('data-src'); }
    });
  });
  function paintAddLabels() {
    root.querySelectorAll('[data-srp2-addlabel]').forEach(function (l) {
      var cb = document.getElementById(l.getAttribute('for'));
      var on = !!(cb && cb.checked);
      l.setAttribute('data-state', on ? 'on' : 'off');
      l.textContent = on ? l.getAttribute('data-on') : l.getAttribute('data-off');
    });
  }
  addonInputs.forEach(function (i) { i.addEventListener('change', paintAddLabels); });
  paintAddLabels();

  var sumbar = root.querySelector('[data-srp2-sumbar]');
  if (sumbar && linesEl) sumbar.addEventListener('click', function () {
    var open = sumbar.getAttribute('aria-expanded') === 'true';
    sumbar.setAttribute('aria-expanded', open ? 'false' : 'true');
    linesEl.hidden = open;
  });

  // Hijack the page form and the sticky bar: the build is a multi-item add.
  var form = section.querySelector('[data-sim-product-form]');
  if (form) {
    form.addEventListener('submit', addBuild, true);
    var btn = form.querySelector('[data-sim-submit]');
    if (btn) btn.addEventListener('click', addBuild, true);
  }
  section.querySelectorAll('[data-sim-sticky-atc]').forEach(function (b) { b.addEventListener('click', addBuild, true); });

  // SRP-specific copy on the surrounding panel: the set ships direct from SRP, so
  // the template's in-house "In stock / free shipping" claims are replaced here.
  (function relabel() {
    // Stocked products keep the template's in-house stock, shipping and button copy.
    if (stocked) return;
    var sub = section.querySelector('.sim-sticky__sub');
    // A product with a price note (custom.price_note) already states what shipping
    // costs, so the bar repeats it instead of the generic checkout line.
    var priceNote = section.querySelector('.sim-price-note span');
    if (sub) sub.textContent = 'Your build · ' + (priceNote ? priceNote.textContent.trim() : 'shipping shown at checkout');
    section.querySelectorAll('[data-sim-sticky-atc]').forEach(function (b) { b.textContent = 'Add build to cart'; });
    var submit = section.querySelector('[data-sim-submit]');
    if (submit) {
      submit.setAttribute('data-label', 'Add build to cart');
      var t = submit.querySelector('[data-sim-submit-text]');
      if (t && !submit.disabled) t.textContent = 'Add build to cart';
    }
    var stock = section.querySelector('[data-sim-stock]');
    if (stock) {
      var vendor = root.getAttribute('data-vendor') || 'the manufacturer';
      stock.setAttribute('data-in-stock', 'Available, ships direct from ' + vendor);
      if (/in stock/i.test(stock.textContent)) stock.textContent = 'Available, ships direct from ' + vendor;
    }
  })();

  // Initial state: first plate dot (Standard) selected.
  if (plateDots.length) {
    var first = plateDots[0];
    var p0 = Number(first.getAttribute('data-price') || 0);
    plate = { name: first.getAttribute('data-name'), price: p0, included: p0 <= 100, variantId: Number(first.getAttribute('data-variant-id')), img: first.getAttribute('data-img') };
  }
  paintFinish();
  paintAll();
}
function bootAll(scope) { (scope || document).querySelectorAll('[data-srp2]').forEach(bootOne); }
if (document.readyState !== 'loading') bootAll(); else document.addEventListener('DOMContentLoaded', function () { bootAll(); });
document.addEventListener('shopify:section:load', function (e) { bootAll(e.target); });
})();